/*global tinymce, jQuery */


/* EDITED */

/*

    Added event case that captures space event and runs 'cleanUp'
    Ensure this is implemented in any upgrades 

*/



/*global tinymce, jQuery */


/* EDITED */

/*

    Added event case that captures space event and runs 'cleanUp'
    Ensure this is implemented in any upgrades 

*/



(function (tinymce, $) {
    'use strict';

    var AutoComplete = function (ed, options) {
        this.editor = ed;

        this.options = $.extend({}, {
            source: [],
            delay: 500,
            queryBy: 'name',
            items: 10
        }, options);

        this.matcher = this.options.matcher || this.matcher;
        this.renderDropdown = this.options.renderDropdown || this.renderDropdown;
        this.render = this.options.render || this.render;
        this.insert = this.options.insert || this.insert;
        this.highlighter = this.options.highlighter || this.highlighter;
        this.lastKeyUp = null;
        this.protocols = ["http:", "https:", "tel:", "mailto:", "ftp:", "smtp:", "pop:", "imap:"];

        this.query = '';
        this.hasFocus = true;
        this.previousNode = false;

        this.renderInput();

        this.bindEvents();
    };

    AutoComplete.prototype = {

        constructor: AutoComplete,

        renderInput: function () {
            var rawHtml =  '<span id="autocomplete">' +
                                '<span id="autocomplete-delimiter">' + this.options.delimiter + '</span>' +
                                '<span id="autocomplete-searchtext"><span class="dummy">\uFEFF</span></span>' +
                            '</span>';

            this.editor.execCommand('mceInsertContent', false, rawHtml);
            this.editor.focus();
            this.editor.selection.select(this.editor.selection.dom.select('span#autocomplete-searchtext span')[0]);
            this.editor.selection.collapse(0);
        },

        bindEvents: function () {

            setTimeout(_.bind(function(){
                
                this.editor.on('keyup', this.editorKeyUpProxy = $.proxy(this.rteKeyUp, this));
                this.editor.on('keydown', this.editorKeyDownProxy = $.proxy(this.rteKeyDown, this), true);
                this.editor.on('click', this.editorClickProxy = $.proxy(this.rteClicked, this)); 
                
                $('body').on('click', this.bodyClickProxy = $.proxy(this.rteLostFocus, this));
            
                // removed as large images triggered scroll when typing hashtags
                // $(this.editor.getWin()).on('scroll', this.rteScroll = $.proxy(function () { this.cleanUp(true); }, this));

            }, this), 0);

        },

        unbindEvents: function () {
            this.editor.off('keyup', this.editorKeyUpProxy);
            this.editor.off('keydown', this.editorKeyDownProxy);
            this.editor.off('click', this.editorClickProxy);

            $('body').off('click', this.bodyClickProxy);

            $(this.editor.getWin()).off('scroll', this.rteScroll);
        },

        rteKeyUp: function (e) {
            var charactersTyped = true,
                $selection;

            if(e.keyIdentifier == 'Shift'){
                return;
            };

            switch (e.which || e.keyCode) {
            //DOWN ARROW
            case 40:
            //UP ARROW
            case 38:
            //SHIFT
            case 16:
            //CTRL
            case 17:
            //ALT
            case 18:
                break;

            //BACKSPACE
            case 8:
                

                // store previous node to check against current context
                // allows us to check if the last node had a length of 1
                // allowing us to ensure the last hashtag charactor was removed
                if(!this.previousNode){
                    this.previousNode = trim($(this.editor.selection.getNode()).text());
                }

                if(this.query.length === 1 && this.previousNode === this.query){
                    charactersTyped = false;
                }
                
                // if query is populated check it's correct by running a check
                // for autocomplete element. if no autocomplete elements exist
                // we need to removed the dropdown
                if(this.query !== "" && 
                        $.trim($(this.editor.getBody()).find('#autocomplete-searchtext').text()) === ""){
                    charactersTyped = false;
                }

                
                if (this.query === '') {
                    this.closeDropdownSelectHashtag(true);
                } else if(charactersTyped === false) {
                    this.query = "";
                    this.closeDropdown();
                } else {
                    this.lookup();
                }
                

                this.previousNode = trim($(this.editor.selection.getNode()).text());

                break;

            //TAB
            case 9:
            //ENTER
            case 13:
                var item = (this.$dropdown !== undefined) ? this.$dropdown.find('li.active') : [];

                if (item.length && this.query.indexOf('//') === -1) {
                    this.select(item.data());
                    this.cleanUp(false);
                } else {
                    this.cleanUp(true);
                }
                break;

            //ESC
            case 27:
                this.cleanUp(true);
                break;

            case 37:
            case 39:
                if(!this.isLinkedInMention){
                    $selection = $(this.editor.dom.select('span#autocomplete')).text().replace("#", "");

                    if($selection !== $(this.editor.selection.getNode()).text()){
                        this.cleanUp(true, true);
                        this.query = "";
                    }
                    
                    break;
                }else{
                    this.lookup();
                }
            //SPACE
            case 32:

                if(this.options.delimiter === ':' && this.query === ''){
                    this.closeDropdownSelectHashtag();
                }

                if (this.options.delimiter === ':' && this.query.indexOf('//') !== -1) {
                    this.cleanUp(true);
                }

                break;
            default:
                var autocompleteNode = this.editor.getBody().querySelector('#autocomplete');
                var previousSibling = ( autocompleteNode && 
                                        autocompleteNode.previousSibling) ? autocompleteNode.previousSibling : false;
                var textContent = ( previousSibling && 
                                    previousSibling.nodeType === 3 && 
                                    previousSibling.textContent.length) ? previousSibling.textContent : false;


                if( textContent && 
                    (textContent + ':').match(this.protocols.join('|'))){

                    this.cleanUp(true);
                    return;
                }

                this.lookup();
            }
        },

        rteKeyDown: function (e) {

            if(e.keyIdentifier == 'Shift'){
                return;
            };
            switch (e.which || e.keyCode) {
             //TAB
            case 9:
            //ENTER
            case 13:
            //ESC
            case 27:
                e.preventDefault();
                break;

            //UP ARROW
            case 38:
                e.preventDefault();
                if (this.$dropdown !== undefined) {
                    this.highlightPreviousResult();
                }
                break;
            //DOWN ARROW
            case 40:
                e.preventDefault();
                if (this.$dropdown !== undefined) {
                    this.highlightNextResult();
                }
                break;
            }

            e.stopPropagation();
        },

        rteClicked: function (e) {
            var $target = $(e.target);

            if (this.hasFocus && $target.parent().attr('id') !== 'autocomplete-searchtext') {
                if(this.isLinkedInMention || this.isTwitterMention){
                    this.cleanUp();

                }else{

                    this.cleanUp(true, true);
                }

            }
        },

        rteLostFocus: function () {
            if (this.hasFocus) {
                this.cleanUp(true);
            }
        },

        lookup: function () {

            this.query = $.trim($(this.editor.getBody()).find('#autocomplete-searchtext').text());

            if (this.$dropdown === undefined) {
                this.show();
            }

            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout($.proxy(function () {
                // Added delimiter parameter as last argument for backwards compatibility.
                var items = $.isFunction(this.options.source) ? this.options.source(this.query, $.proxy(this.process, this), this.options.delimiter) : this.options.source;
                if (items) {
                    this.process(items);
                }
            }, this), this.options.delay);
        },

        matcher: function (item) {
            return ~item[this.options.queryBy].toLowerCase().indexOf(this.query.toLowerCase());
        },

        sorter: function (items) {
            var beginswith = [],
                caseSensitive = [],
                caseInsensitive = [],
                item;

            while ((item = items.shift()) !== undefined) {
                if (!item[this.options.queryBy].toLowerCase().indexOf(this.query.toLowerCase())) {
                    beginswith.push(item);
                } else if (~item[this.options.queryBy].indexOf(this.query)) {
                    caseSensitive.push(item);
                } else {
                    caseInsensitive.push(item);
                }
            }

            return beginswith.concat(caseSensitive, caseInsensitive);
        },

        highlighter: function (text) {
            return text.replace(new RegExp('(' + this.query.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1') + ')', 'ig'), function ($1, match) {
                return '<strong>' + match + '</strong>';
            });
        },

        show: function () {
            var offset = this.editor.inline ? this.offsetInline() : this.offset();

            this.$dropdown = $(this.renderDropdown())
                                .css({ 'top': offset.top, 'left': offset.left });

            $('body').append(this.$dropdown);

            this.$dropdown.on('click', $.proxy(this.autoCompleteClick, this));
        },

        process: function (data, showLoading, strDropDownMessage, type) {
            var _this = this;

            if (!this.hasFocus) {
                return;
            }

            setTimeout(function(){
                var offset = _this.editor.inline ? _this.offsetInline() : _this.offset();
                _this.$dropdown.css({ 'top': offset.top, 'left': offset.left });
            }, 100);

            if(showLoading && this.$dropdown){

                this.$dropdown.show();

                this.$dropdown.find('.alert-block').remove();

                this.$dropdown.prepend('<div class="alert-block alert-color-' + type + '">' + strDropDownMessage + '</div>');

                return;
            }

            var _this = this,
                result = [],
                items = $.grep(data, function (item) {
                    return _this.matcher(item);
                });


            items = _this.sorter(items);

            items = items.slice(0, this.options.items);

            $.each(items, function (i, item) {
                var $element = $(_this.render(item, i));

                $element.html($element.html().replace($element.text(), _this.highlighter($element.text())));

                $.each(items[i], function (key, val) {
                    $element.attr('data-' + key, val);
                });

                result.push($element[0].outerHTML);
            });

            if (result.length) {
                this.$dropdown.html(result.join('')).show();

                if(this.$dropdown.find('.icon-linkedin-sign').length){
                    this.isLinkedInMention = true;
                }else{
                    this.isLinkedInMention = false;
                }

                if(this.$dropdown.find('.icon-twitter').length){
                    this.isTwitterMention = true;
                }

                if(strDropDownMessage){
                    this.$dropdown.prepend('<div class="alert-block alert-color-' + type + '">' + strDropDownMessage + '</div>');
                }

            } else {
                this.$dropdown.hide();
            }
        },

        renderDropdown: function () {
            return '<ul class="rte-autocomplete dropdown-menu"></ul>';
        },

        render: function (item) {
            return '<li>' +
                        '<a href="javascript:;"><span>' + item[this.options.queryBy] + '</span></a>' +
                    '</li>';
        },

        autoCompleteClick: function (e) {
            var item = $(e.target).closest('li').data();
            if (!$.isEmptyObject(item)) {
                this.select(item);
                this.cleanUp(false);
            }
            e.stopPropagation();
            e.preventDefault();
        },

        highlightPreviousResult: function () {
            var currentIndex = this.$dropdown.find('li.active').index(),
                index;

            if(this.$dropdown.find('>div').length && currentIndex > 0 ){
                currentIndex = currentIndex - 1;
            }
    
            index = (currentIndex === 0) ? this.$dropdown.find('li').length - 1 : --currentIndex;

            this.$dropdown.find('li').removeClass('active').eq(index).addClass('active');
        },

        highlightNextResult: function () {
            var currentIndex = this.$dropdown.find('li.active').index(),
                index;

            if(this.$dropdown.find('>div').length && currentIndex > 0 ){
                currentIndex = currentIndex - 1;
            }

            index = (currentIndex === this.$dropdown.find('li').length - 1) ? 0 : ++currentIndex;

            this.$dropdown.find('li').removeClass('active').eq(index).addClass('active');
        },

        select: function (item) {
            this.editor.focus();
            var selection = this.editor.dom.select('span#autocomplete')[0];
            this.editor.dom.remove(selection);
            this.editor.execCommand('mceInsertContent', false, this.insert(item));
        },

        insert: function (item) {
            return '<span>' + item[this.options.queryBy] + '</span>&nbsp;';
        },

        cleanUp: function (rollback, cancelFocusArg) {
            var cancelFocus = (typeof cancelFocusArg !== undefined) ? cancelFocusArg : false; 

            this.unbindEvents();
            this.hasFocus = false;

            if (this.$dropdown !== undefined) {
                this.$dropdown.remove();
                delete this.$dropdown;
            }

          if (rollback) {
                var text = this.query,
                    $selection = $(this.editor.dom.select('span#autocomplete')),
                    replacement = $('<p>' + this.options.delimiter + text + '</p>')[0].firstChild,
                    focus = false;    
                
                if($selection.length > 0){
                    focus = $(this.editor.selection.getNode()).offset().top === ($selection.offset().top + (($selection.outerHeight() - $selection.height()) / 2));
                }

                this.editor.dom.replace(replacement, $selection[0]);
   
                if(focus && cancelFocus !== true) {
                    this.editor.selection.select(replacement);
                    this.editor.selection.collapse();
                }
            }
        },

        // close dropdown without unbinding events for displaying hashtags
        // useful when a hashtag's text has been removed but the hashtag remains
        // and events need to be bound so typing a new hashtag displays the dropdown
        closeDropdown: function () {

            if (this.$dropdown !== undefined) {
                this.$dropdown.remove();
                delete this.$dropdown;
            } 

        },

        // similar action to clean up but tailored to work with the space event
        closeDropdownSelectHashtag: function (removeHashtagArg) {
            var $selection,
                text,
                removeHashtag = (typeof removeHashtagArg !== undefined) ? removeHashtagArg : false;

            this.unbindEvents();
            this.hasFocus = false;
            this.query = "";

            if (this.$dropdown !== undefined) {
                this.$dropdown.remove();
                delete this.$dropdown;
            }


            $selection = $(this.editor.dom.select('span#autocomplete'));
            

            // removing a hashtag allows backspace to correctly remove an *active hashtag
            // with one press of backspace. previously backspace on the hash charachter
            // would remove the span and active state of the hashtag but not remove the
            // hashtag
            // *active : active hashtag is one with dropdown events still bound
            if(removeHashtag){
               text = document.createTextNode("");    
            } else {
               text = $('<p>' + $selection.find("#autocomplete-delimiter").text() + $selection.find("#autocomplete-searchtext").text().replace(/\uFEFF/g, '') + '</p>')[0].firstChild;
            }

            this.editor.dom.replace(text, $selection);

            this.editor.selection.select(text);
            this.editor.selection.collapse();

        },

        offset: function () {
            var rtePosition = $(this.editor.getContainer()).offset(),
                contentAreaPosition = $(this.editor.getContentAreaContainer()).position(),
                nodePosition = $(this.editor.dom.select('span#autocomplete')).position();

            return {
                top: rtePosition.top + contentAreaPosition.top + nodePosition.top + $(this.editor.selection.getNode()).innerHeight() - $(this.editor.getDoc()).scrollTop() + 5,
                left: rtePosition.left + contentAreaPosition.left + nodePosition.left
            };
        },

        offsetInline: function () {
            var nodePosition = $(this.editor.dom.select('span#autocomplete')).offset();

            return {
                top: nodePosition.top + $(this.editor.selection.getNode()).innerHeight() + 5,
                left: nodePosition.left
            };
        }

    };

    tinymce.create('tinymce.plugins.Mention', {

        init: function (ed) {

            var autoComplete,
                autoCompleteData = ed.getParam('mentions');

            // If the delimiter is undefined set default value to ['@'].
            // If the delimiter is a string value convert it to an array. (backwards compatibility)
            autoCompleteData.delimiter = (autoCompleteData.delimiter !== undefined) ? !$.isArray(autoCompleteData.delimiter) ? [autoCompleteData.delimiter] : autoCompleteData.delimiter : ['@'];

            function prevCharIsSpace() {
                var start = ed.selection.getRng(true).startOffset,
                      text = ed.selection.getRng(true).startContainer.data || '',
                      charachter = text.substr(start - 1, 1);

                return (!!$.trim(charachter).length) ? false : true;
            }

            ed.on('keypress', function (e) {
                var charentered = String.fromCharCode(e.which || e.keyCode),
                    delimiterIndex = $.inArray(charentered, autoCompleteData.delimiter);
                
                if ((delimiterIndex > -1 && charentered === ':') || (delimiterIndex > -1 && prevCharIsSpace())) {
                    if (autoComplete === undefined || (autoComplete.hasFocus !== undefined && !autoComplete.hasFocus)) {
                        e.preventDefault();
                        // Clone options object and set the used delimiter.
                        autoComplete = new AutoComplete(ed, $.extend({}, autoCompleteData, { delimiter: autoCompleteData.delimiter[delimiterIndex] }));
                    }
                }
            });

        },

        getInfo: function () {
            return {
                longname: 'mention',
                author: 'Steven Devooght',
                version: tinymce.majorVersion + '.' + tinymce.minorVersion
            };
        }
    });

    tinymce.PluginManager.add('mention', tinymce.plugins.Mention);

}(tinymce, jQuery));